import { ProjectActionTypes } from "./constants";

const initialState = {
  projects: [],
  selectedProject: null,
  error: null,
};

export default function projectReducer(state = initialState, action) {
  switch (action.type) {
    case ProjectActionTypes.SET_PROJECTS:
      return {
        ...state,
        projects: action.payload,
        error: null,
      };
    case ProjectActionTypes.SET_PROJECTS_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case ProjectActionTypes.SET_SELECTED_PROJECT:
      return {
        ...state,
        selectedProject: action.payload,
      };
    default:
      return state;
  }
} 